import { useEffect } from "react";
import { useVideoPlayerRefs } from "../contexts/VideoPlayerRefs";
import { SourceProps } from "../types/sourceProps";

const isMp4 = (src: string) => src.includes(".mp4");

export const useMp4Source = ({ src, startTime }: SourceProps) => {
  const { video } = useVideoPlayerRefs();

  useEffect(() => {
    if (video.current !== null && src !== undefined && isMp4(src)) {
      const element = video.current;

      const handler = () => {
        if (startTime !== undefined) {
          element.currentTime = startTime;
        }
      };

      element.addEventListener("loadedmetadata", handler);
      element.src = src;

      return () => {
        element.removeEventListener("loadedmetadata", handler);
      };
    }
  }, [startTime, video, src]);
};
